const overlayCompanyConnectionManagement = ({ connections, companyConnections } = {}) => {
  const safeConnections = Array.isArray(connections) ? connections : [];
  const companyConnectionById = new Map((Array.isArray(companyConnections) ? companyConnections : []).filter((connection) => Boolean(connection?.credentialId)).map((connection) => [connection.credentialId, connection]));

  return safeConnections.map((connection) => {
    if (connection?.isCompany !== true) {
      return connection;
    }

    const companyConnection = connection?.credentialId ? companyConnectionById.get(connection.credentialId) : null;

    if (!companyConnection) {
      return connection;
    }

    return {
      ...connection,
      isOwner: companyConnection?.isOwner === true,
      canManage: companyConnection?.canManage === true
    };
  });
};

export default overlayCompanyConnectionManagement;
